import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';
import { BrowserTransferStateModule } from '../modules/transfer-state/browser-transfer-state.module';
import { SDKBrowserModule } from "./shared/sdk/index";

import 'jquery';
import 'bootstrap';
import 'social-share-kit/dist/js/social-share-kit';
require ('./../modules/modernizr');
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

@NgModule({
	imports: [
    BrowserTransferStateModule,
    BrowserAnimationsModule,
    SDKBrowserModule.forRoot(),
    AppModule
	],
  providers: [
    { provide: 'isBrowser', useValue: true },
    { provide: 'isNode', useValue: false }
  ],
  bootstrap: [ AppComponent ]
})
export class BrowserAppModule {}



// WEBPACK FOOTER //
// ./src/app/browser-app.module.ts